import { connect } from '@ardoq/rxbeach';
import { createEmbedViewerUrl } from 'integrations/lucidchart/utils';
import styled from 'styled-components';
import { lucidSlide$ } from './lucidSlide$';
import { LoadingOverlay } from '@ardoq/loader';

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: none;
`;

const LucidSlideBase = ({
  documentId,
  clientId,
}: {
  documentId: string;
  clientId: string | null;
}) => {
  if (!clientId) {
    return <LoadingOverlay />;
  }
  const iframeSource = createEmbedViewerUrl({
    documentId: documentId,
    clientId: clientId,
  });

  return <FullScreenIframe src={iframeSource} />;
};

export const LucidSlide = connect(LucidSlideBase, lucidSlide$);
